module.exports = __webpack_public_path__ + "media/microflavours.2fe22dfe.mp4";